import { jsx as _jsx } from 'react/jsx-runtime.js';
import { DefaultContent } from './DefaultContent/index.js';
import { LoggedInContent } from './LoggedInContent.js';
import { ReturningContent } from './ReturningContent.js';
const getLeftSideContent = (variant) => {
    switch (variant) {
        case 'twoStepAppleUpdateEmail':
            return _jsx(LoggedInContent, {});
        case 'twoStepReturning':
            return _jsx(ReturningContent, {});
        default:
            return _jsx(DefaultContent, {});
    }
};
export default getLeftSideContent;
//# sourceMappingURL=getLeftSideContent.js.map